import { CandidOrgId, CandidUrl } from '@/constants/candidUrl';
import HOSTS from '@/constants/hosts';

export function candidBaseUrl(host: string): string {
  return host === HOSTS['production'] ? CandidUrl.Production : CandidUrl.Staging;
}

export function candidOrgId(host: string): string {
  return host === HOSTS['production'] ? CandidOrgId.Production : CandidOrgId.Staging;
}

export function candidClaimsUrl(host: string, searchTerm: string): string {
  const baseUrl = candidBaseUrl(host);
  const orgId = candidOrgId(host);
  return `${baseUrl}/${orgId}/claims?search_term=${encodeURIComponent(searchTerm)}`;
}

export function candidClaimUrl(host: string, claimId: string): string {
  const baseUrl = candidBaseUrl(host);
  const orgId = candidOrgId(host);
  return `${baseUrl}/${orgId}/claims/${encodeURIComponent(claimId)}`;
}

export function candidRemitsUrl(host: string, checkNumber: string): string {
  const baseUrl = candidBaseUrl(host);
  const orgId = candidOrgId(host);
  return `${baseUrl}/${orgId}/remits?checkNumber=${encodeURIComponent(checkNumber)}&includePostedRemits=true`;
}

export function candidPatientUrl(host: string, patientId: string): string {
  const baseUrl = candidBaseUrl(host);
  const orgId = candidOrgId(host);
  return `${baseUrl}/${orgId}/patients/${encodeURIComponent(patientId)}`;
}
